import { predicateNumber } from 'utilities/isType.js';
import { CellRenderType, ComponentTester } from './renderCell.js';

export const RenderWindChill: ComponentTester<CellRenderType.windchill> = ({ data }) => {
  if (predicateNumber(data?.dataSet)) {
    return <small className="u-block u-textBold">{`${data?.dataSet}°`}</small>;
  }
  return <small className="u-block u-textBold">{`${data?.dataSet ?? 'n/a'}`}</small>;
};
